module.exports = __webpack_public_path__ + "img/symbol_1.cab70893.png";